var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C6.61779 3.5 2.25 7.86779 2.25 13.25C2.25 18.6322 6.61779 23 12 23C17.3822 23 21.75 18.6322 21.75 13.25C21.75 7.86779 17.3822 3.5 12 3.5ZM12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83579 11.25 8.25V13.25C11.25 13.6642 11.5858 14 12 14C12.4142 14 12.75 13.6642 12.75 13.25V8.25Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 1.75C8.25 2.16421 8.58579 2.5 9 2.5L15 2.5C15.4142 2.5 15.75 2.16421 15.75 1.75C15.75 1.33579 15.4142 0.999999 15 0.999999L9 1C8.58579 1 8.25 1.33579 8.25 1.75Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.2683bfd6ca62cf8df2016209ff441170.svg";
export { ForwardRef as ReactComponent };